import { memo, lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Header from '../Header';

const Footer = lazy(() => import('../Footer'));

const SectionLoader = memo(() => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
    }}
  >
    <CircularProgress sx={{ color: 'primary.main' }} />
  </Box>
));

SectionLoader.displayName = 'SectionLoader';

const Layout = memo(() => {
  return (
    <>
      <Header />
      <Box component="main">
        <Outlet />
      </Box>
      <Suspense fallback={<SectionLoader />}>
        <Footer />
      </Suspense>
    </>
  );
});

Layout.displayName = 'Layout';

export default Layout;
